import { ASSETS } from "@/lib/site";

// Asymmetric / diamond mosaic — now populated with real property photos.
export default function Escape() {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative bg-[color:var(--sh-charcoal)] py-24 sm:py-32 overflow-hidden"
    >
      {/* soft amber lamp glow */}
      <div className="absolute top-1/3 -right-40 w-[480px] h-[480px] rounded-full bg-[color:var(--sh-amber-glow)] blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-14 items-center">
        {/* Diamond / asymmetric mosaic */}
        <div className="lg:col-span-7 sh-reveal">
          <div className="relative w-full aspect-square max-w-[620px] mx-auto">
            {/* center tall image — garden bench in the mist */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[52%] aspect-[3/4] rounded-3xl overflow-hidden z-20 shadow-[0_40px_100px_-20px_rgba(0,0,0,0.6)]">
              <img
                src={ASSETS.gallery1}
                alt="Garden bench looking into the mist at Sardar House"
                loading="lazy"
                className="w-full h-full object-cover sh-crop-mobile"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/5" />
            </div>

            {/* top-right rotated tile — dusk A-frame */}
            <div className="absolute top-0 right-0 w-[44%] aspect-square rotate-[10deg] rounded-3xl overflow-hidden z-10 shadow-[0_30px_80px_-25px_rgba(0,0,0,0.55)]">
              <div className="w-full h-full -rotate-[10deg] scale-[1.25]">
                <img
                  src={ASSETS.gallery3}
                  alt="A-frame cabin glowing at dusk"
                  loading="lazy"
                  className="w-full h-full object-cover sh-crop-mobile-strong"
                />
              </div>
            </div>

            {/* bottom-left rotated tile — cabin in daylight */}
            <div className="absolute bottom-0 left-0 w-[48%] aspect-[5/4] -rotate-[8deg] rounded-3xl overflow-hidden z-10 shadow-[0_30px_80px_-25px_rgba(0,0,0,0.55)]">
              <div className="w-full h-full rotate-[8deg] scale-[1.2]">
                <img
                  src={ASSETS.gallery5}
                  alt="A-frame cabin among the trees"
                  loading="lazy"
                  className="w-full h-full object-cover sh-crop-mobile"
                />
              </div>
            </div>

            {/* tiny accent tag */}
            <div className="absolute -bottom-2 right-6 z-30 sh-nav-pill rounded-full px-4 py-2 text-[10px] uppercase tracking-widest text-[color:var(--sh-cream)] flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--sh-amber)]" />
              2,500 m above sea
            </div>
          </div>
        </div>

        {/* Copy */}
        <div className="lg:col-span-5 sh-reveal">
          <div className="text-xs uppercase tracking-[0.35em] text-[color:var(--sh-amber)] mb-5">
            The Escape
          </div>
          <h2 className="sh-display text-[color:var(--sh-cream)] text-4xl sm:text-5xl lg:text-6xl font-medium">
            Slow<br />mornings.<br />
            <span className="text-[color:var(--sh-amber)]">Long</span> nights.
          </h2>
          <p className="mt-6 text-[color:var(--sh-cream-dim)] leading-relaxed max-w-md">
            Wake to mist folded into the pines. Walk the ridge road. Come back to
            cardamom chai. When the sky turns amber, we light the fire and pull
            the chairs out. That’s the whole plan.
          </p>

          <ul className="mt-8 space-y-3 text-sm text-[color:var(--sh-cream)]">
            {["Pine forest walks", "Bonfire evenings", "Sunrise from the balcony"].map((item) => (
              <li key={item} className="flex items-center gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--sh-amber)]" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
